<div *ngIf="accountDetailsId" class="container">
  <a fxShow fxHide.lt-sm class="link" (click)="onChangePassword()">{{ 'CHANGE_PASSWORD' | translate }}</a>
  <a fxHide fxShow.lt-sm class="link" (click)="onChangePassword()">{{ 'CHANGE' | translate }}</a>
</div>
